import { METHOD, AI_END_POINTS } from '../../constants/constant';
import { createApi } from '@reduxjs/toolkit/query/react';
import { customAiBaseQuery } from '../customBaseQuery';

import { AiChatMessage, HandoverChatResponse, StructuredAiParserTaskResponse } from '@handover/shared-types';

export const aiApi = createApi({
  reducerPath: 'aiApi',
  baseQuery: customAiBaseQuery,
  endpoints: builder => ({
    sendMessageToAI: builder.mutation({
      query: (message: string) => ({
        url: AI_END_POINTS.assistant,
        method: METHOD.POST,
        body: { message },
      }),
      transformResponse: (response: { data: { success: boolean; aiMessage: string } }) => response.data.aiMessage,
    }),
    sendMessageToHandoverChat: builder.mutation<
      HandoverChatResponse,
      { handoverId: string; messages: AiChatMessage[] }
    >({
      query: body => ({
        url: AI_END_POINTS.handoverChat,
        method: METHOD.POST,
        body,
      }),
      transformResponse: (response: { data: HandoverChatResponse }) => response.data,
    }),

    uploadFileToAI: builder.mutation({
      query: ({ file, handoverId, mimeType }: { file: string; handoverId: string; mimeType: string }) => ({
        url: AI_END_POINTS.parser,
        method: 'POST',
        body: { file, handoverId, mimeType }, // Pass handoverId along with the file
      }),
      transformResponse: (response: {
        message: string;
        text: string;
        handoverId: string;
        aiResponse: StructuredAiParserTaskResponse;
      }) => ({
        message: response.message,
        text: response.text,
        handoverId: response.handoverId,
        aiResponse: response.aiResponse,
      }),
    }),
  }),
});

export const {
  useSendMessageToAIMutation,
  useSendMessageToHandoverChatMutation,
  useUploadFileToAIMutation,
} = aiApi;
